<div class="dialog-title">Tax Details</div>

<div class="value-container">
  <div class="content-wrapper full">
    <div class="label-f">Tax Code</div>
    <div class="value-f">SST</div>
  </div>

  <div class="content-wrapper full">
    <div class="label-f">Description</div>
    <div class="value-f">Sales services</div>
  </div>
  <div class="content-wrapper full">
    <div class="label-f">Tax Class</div>
    <div class="value-f">RM 1,300,000.00</div>
  </div>
  <div class="content-wrapper">
    <div class="label-f">Effective Date</div>
    <div class="value-f">05 Dec 2020 | <span class="highlight-f">8%</span></div>
    <div class="value-f">
      06 Dec 2020 | <span class="highlight-f">16%</span>
    </div>
  </div>
</div>
